import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PartnerBasicDataComponent } from './components/partner-basic-data/partner-basic-data.component';
import { PartnerRegistrationComponent } from './components/partner-registration/partner-registration.component';
import { PartnerSiteComponent } from './components/partner-site/partner-site.component';
import { PartnerUserRegistrationComponent } from './components/partner-user-registration/partner-user-registration.component';

const routes: Routes = [
  { path: 'partner-registration', component: PartnerRegistrationComponent },
  {
    path: 'partner-user-registration',
    component: PartnerUserRegistrationComponent,
  },
  { path: 'partner-basic-data', component: PartnerBasicDataComponent },
  { path: 'partner-site', component: PartnerSiteComponent },
  { path: '', redirectTo: 'partner-registration', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TelesalesRoutingModule {}
